import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { getMessage } from './actions'
import { searchMessages } from '../inbox/actions'
import App from '../common/app'
import EmaialAdminSentMessage from './components/index'
let unsubscribe = function () {}

function render () {
  renderWithRoot(
    <App active="cart" {...getState()} {...appActions}>
      <EmaialAdminSentMessage {...getState()} {...appActions} />
    </App>,
    document.querySelector('#app')
  )
}

export function enter (context, next) {
  unsubscribe = subscribe(render)
  // refresh read/unread
  searchMessages(getState().session.user.email, 1, 8, "byEmail", getState().session.user.email) 
  getMessage(context.params.messageId)
  render()
}

export function exit (context, next) {
  unsubscribe()
  next()
}
